import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import { Button, Textarea, Input } from "../Form";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import SearchBar from "../SearchBar";
import { useForm } from "react-hook-form";
import ConfirmationAlert from "../ConfirmationAlert";
import NewPatientFast from "./NewPatientFast";
import {
  getVisitasByCitaId,
  resetVisita,
} from "../../redux/features/visitasSlice";
import {
  createCita,
  getCitas,
  updateCita,
  deleteCita,
} from "../../redux/features/citasSlice";

function AddAttentionModal({ isOpen, closeModal, operation, patients }) {
  // Configuración automática de fechas y horas
  const now = new Date();
  const endTime = new Date(now);
  endTime.setMinutes(now.getMinutes() + 30); // 30 minutos después

  const [openPatient, setOpenPatient] = useState(false);
  const [selected, setSelected] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    now.toISOString().split("T")[0]
  );
  const navigate = useNavigate();

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  // Configurar valores iniciales
  useEffect(() => {
    if (isOpen) {
      const today = new Date().toISOString().split("T")[0];
      setSelectedDate(today);
      setValue("fecha", new Date(today).toISOString());
      setValue("hora_inicio", now.toISOString());
      setValue("hora_fin", endTime.toISOString());
      setValue("tipo_evento", "Consulta");
      setValue("estado", "cerrada");
      setValue("motivo", "Emergencia");
    }
  }, [isOpen, setValue]);

  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);

    // Convertir la fecha seleccionada a formato ISO
    const dateObj = new Date(newDate);
    setValue("fecha", dateObj.toISOString());
  };

  const onSubmit = async (data) => {
    if (!selected?.id) {
      toast.error("Seleccione al Paciente Primero!");
      return;
    }

    // Crear objetos de fecha correctamente formateados
    const fechaObj = new Date(selectedDate);
    const horaInicioObj = new Date(fechaObj);
    horaInicioObj.setHours(now.getHours(), now.getMinutes(), now.getSeconds());

    const horaFinObj = new Date(fechaObj);
    horaFinObj.setHours(
      endTime.getHours(),
      endTime.getMinutes(),
      endTime.getSeconds()
    );

    const citaData = {
      ...data,
      patient_id: selected.id,
      fecha: fechaObj.toISOString(),
      hora_inicio: horaInicioObj.toISOString(),
      hora_fin: horaFinObj.toISOString(),
      tipo_evento: "Consulta",
      estado: "cerrada",
    };

    ConfirmationAlert({
      title: "Iniciar Atención Médica",
      text: "¿Está seguro de iniciar esta atención médica?",
      onAccept: async () => {
        try {
          // Primero creamos la cita
          const res = await operation.dispatch(createCita(citaData));

          if (res.error) {
            throw new Error(res.error);
          }

          // Luego creamos la visita asociada
          const visitaResponse = await operation.dispatch(
            getVisitasByCitaId(res?.payload?.id)
          );

          if (visitaResponse?.error) {
            throw new Error(visitaResponse.error);
          }

          // Actualizamos listados
          operation.dispatch(getCitas());

          toast.success("Atención médica iniciada exitosamente!", {
            duration: 5000,
          });

          // Navegamos a la ficha del paciente
          navigate(`/patients/preview/${selected.id}`);
          closeModal();
        } catch (error) {
          toast.error(`Error al iniciar atención: ${error.message}`, {
            duration: 5000,
          });
        }
      },
    });
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title="Iniciar Atención Médica"
      width="max-w-2xl"
    >
      <div className="flex-colo gap-6">
        <div className="grid sm:grid-cols-12 gap-4 w-full items-center">
          {openPatient && (
            <NewPatientFast
              open={openPatient}
              setOpen={setOpenPatient}
              setPatient={setSelected}
            />
          )}
          <div className="sm:col-span-12">
            <SearchBar
              placeholder="Escriba nombre o CI para buscar al paciente"
              data={patients}
              setSelected={setSelected}
              value={
                selected
                  ? `${
                      selected.persona.ci.length > 10
                        ? selected.persona.ci.slice(0, 8)
                        : selected.persona.ci
                    } - ${selected.persona.nombre} ${
                      selected.persona.apellidos
                    }`
                  : ""
              }
              setOpen={setOpenPatient}
            />
          </div>
        </div> 

        {/* Campo de fecha agregado */}
        <div className="grid sm:grid-cols-12 gap-4 w-full">
          <div className="sm:col-span-6">
            <label className="text-sm text-text font-semibold">
              Fecha de atención
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-full mt-2 px-4 py-3 border border-border rounded-lg text-sm focus:border-subMain focus:outline-none"
            />
          </div>
        </div>

        <div className="flex justify-end w-full gap-4">
          <Button
            label="Cancelar"
            onClick={closeModal}
            className="bg-gray-300 text-gray-700"
          />
          <Button
            label="Iniciar Atención"
            onClick={handleSubmit(onSubmit)}
            className="bg-subMain text-white"
            disabled={!selected}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddAttentionModal;
